/* import __COLOCATED_TEMPLATE__ from './upfront-email-collector.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();